import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ExceptionService } from '../../core/services/exception.service';
import { SpinnerService } from '../../core/spinner/spinner.service';
import { Observable } from 'rxjs';
import { CONFIG } from '../../core/config';
import { catchError, finalize } from 'rxjs/operators';
import { eServiceCategory } from '../../core/models/eServiceCategory';
import { administrativeProcedure } from '../../core/models/administrativeProcedure';
import { AdministrativeProcedureDetailsViewModel } from '../../core/models/administrativeProcedureDetailsViewModel';

@Injectable({
  providedIn: 'root'
})
export class EServicesService {

  constructor(private _http: HttpClient,
    private _exceptionService: ExceptionService,
    private _spinnerService: SpinnerService) { }

  getAlleServicesCategories(langID: number): Observable<eServiceCategory[]> {
    this._spinnerService.show();
    return this._http.get<eServiceCategory[]>(CONFIG.baseUrls.administrativeProcedures.getAlleServicesCategories + langID)
        .pipe(
            catchError(this._exceptionService.catchBadResponse),
            finalize(() => this._spinnerService.hide())
        );
  }

  getAlleServicesSubCategories(langID: number, parentId: number): Observable<eServiceCategory[]> {
    this._spinnerService.show();
    return this._http.get<eServiceCategory[]>(CONFIG.baseUrls.administrativeProcedures.getServicesSubCategoriesByParentID + langID + '/' + parentId)
        .pipe(
            catchError(this._exceptionService.catchBadResponse),
            finalize(() => this._spinnerService.hide())
        );
  }

  getAdministrativeProceduresByCategoryID(langID: number, categoryId : number): Observable<administrativeProcedure[]>{
    this._spinnerService.show();
    return this._http.get<administrativeProcedure[]>(CONFIG.baseUrls.administrativeProcedures.getAdministrativeProceduresByCategoryID + langID + '/' + categoryId)
        .pipe(
            catchError(this._exceptionService.catchBadResponse),
            finalize(() => this._spinnerService.hide())
        );
  }

  getAdministrativeProcedureDetailsByID(langID: number, administrativeProcedureId : number): Observable<AdministrativeProcedureDetailsViewModel>{
    this._spinnerService.show();
    return this._http.get<AdministrativeProcedureDetailsViewModel>(CONFIG.baseUrls.administrativeProcedures.getAdministrativeProcedureDetailsByID + langID + '/' + administrativeProcedureId)
        .pipe(
            catchError(this._exceptionService.catchBadResponse),
            finalize(() => this._spinnerService.hide())
        );
  }
  
  downloadAdmProcedureDocument(id: number, langID: number): Observable<Blob> {
    this._spinnerService.show();
    return this._http.post<Blob>(CONFIG.baseUrls.admin.administrativeProcedures.downloadAmdProcedureDocument, { ID: id, LangID: langID }, { responseType: 'blob' as 'json' })
        .pipe(
            catchError(this._exceptionService.catchBadResponse),
            finalize(() => this._spinnerService.hide())
        );
  }

  getAdministrativeProcedureByName(langID: number, name: string) {
    return this._http.get<any[]>(CONFIG.baseUrls.administrativeProcedures.getAdministrativeProceduresByName + langID + '/' + name)
        .pipe(
            catchError(this._exceptionService.catchBadResponse),
            finalize(() => this._spinnerService.hide())
        );
  }
}
